import React, { useState } from "react";
import DataTable from "../../Robuts Components/DataTable";
import { Modal, Button, Spinner } from "react-bootstrap";
import { IoReturnDownForward } from "react-icons/io5";
import {
  acceptNewStudent,
  deleteStudent,
} from "../../../../backend/firebaseFunctions";
import TipCard from "../../Robuts Components/TipCard";

function NewStudentsPane({
  students,
  groups,
  setCurrentTab,
  userID,
  userData,
  activateAlert,
}) {
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showStudentApproveModal, setShowStudentApproveModal] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);

  const onNewStudentRowClick = (student) => {
    setSelectedStudent(student);
    setShowStudentApproveModal(true);
  };

  // Helper to get the correct UID for student actions
  const getTargetUserID = () => {
    if (
      userData &&
      userData.userType === "coach" &&
      userData.userOrganization?.organizationOwnerID
    ) {
      return userData.userOrganization.organizationOwnerID;
    }
    return userID;
  };

  const handleDeleteStudent = async () => {
    setIsDeleting(true);
    try {
      const isStudentDeleted = await deleteStudent(
        getTargetUserID(),
        selectedStudent.id
      );
      if (isStudentDeleted) {
        activateAlert("success", "אליפות!", "החניך נמחק מהמערכת");
        // Don't update local state - let the real-time listener handle it
      }
    } catch (error) {
      activateAlert("danger", "שגיאה!", "לא הצלחנו למחוק את החניך, נסה שוב");
    }
    setIsDeleting(false);
    setShowStudentApproveModal(false);
    setShowDeleteConfirmationModal(false);
  };

  const handleAcceptStudent = async () => {
    setIsAccepting(true);
    try {
      const isStudentAccepted = await acceptNewStudent(
        getTargetUserID(),
        selectedStudent.id
      );
      if (isStudentAccepted) {
        activateAlert("success", "אליפות!", "החניך אושר במערכת");
        // Don't update local state - let the real-time listener handle it
      }
    } catch (error) {
      activateAlert("danger", "שגיאה!", "לא הצלחנו לאשר את החניך, נסה שוב");
    }
    setIsAccepting(false);
    setShowStudentApproveModal(false);
  };

  // Filter students to only show those with status 'toReview'
  const studentsToReview = students.filter(
    (student) => student.status === "toReview"
  );

  // Modern design styles
  const mainBg = {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f8fafc 0%, #e3e9f7 100%)",
    padding: "32px 0",
  };
  const containerStyle = {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 16px",
  };
  const headerStyle = {
    fontWeight: 800,
    fontSize: "2.5rem",
    letterSpacing: 1,
    marginBottom: 24,
    textAlign: "center",
  };
  const sectionCardStyle = {
    marginBottom: 40,
    background: "#fff",
    borderRadius: 18,
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    padding: 24,
    direction: "ltr",
  };
  const backButtonStyle = {
    fontWeight: 700,
    fontSize: "1.2rem",
    borderRadius: 999,
    padding: "12px 32px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    marginBottom: 32,
  };
  // Modern empty state
  const hasAnyNewStudents = studentsToReview && studentsToReview.length > 0;

  return (
    <div style={mainBg}>
      <style>{`
        .modern-student-card {
          border-radius: 16px !important;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
          background: #fff !important;
          transition: box-shadow 0.2s, transform 0.2s;
        }
        .modern-student-card:hover {
          box-shadow: 0 4px 24px #1976d233 !important;
          transform: translateY(-2px) scale(1.01);
        }
        .modern-section-header-icon {
          font-size: 1.3em;
          margin-left: 8px;
        }
        .modern-back-btn {
          border-radius: 999px !important;
          font-weight: 700 !important;
          font-size: 1.2rem !important;
          padding: 12px 32px !important;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
        }
        .modern-modal .modal-content {
          border-radius: 18px !important;
          background: #f8fafc !important;
        }
        .modern-modal .modal-header {
          border-radius: 18px 18px 0 0 !important;
        }
        .modern-modal .modal-footer {
          border-radius: 0 0 18px 18px !important;
        }
        .modern-form-input, .modern-form-input:focus {
          border-radius: 10px !important;
          box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;
          border: 1px solid #e0e0e0 !important;
          background: #fff !important;
        }
        .modern-students-table {
          border-radius: 16px !important;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
          background: #fff !important;
          padding: 16px;
        }
      `}</style>
      <div style={containerStyle}>
        <h1 style={headerStyle}>ספורטאים חדשים</h1>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <Button
            variant="secondary"
            onClick={() => setCurrentTab("students")}
            className="modern-back-btn"
            style={backButtonStyle}
          >
            חזור
            <IoReturnDownForward size={24} style={{ marginLeft: "2vh" }} />
          </Button>
        </div>
        <TipCard>בכדי לאשר/לסרב ספורטאי חדש, לחץ עליו!</TipCard>

        {/* Modern empty state if no new students */}
        {!hasAnyNewStudents && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 320,
              color: "#888",
              fontWeight: 600,
              fontSize: "1.3rem",
              background: "#fff",
              borderRadius: 18,
              boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              margin: "48px auto 0 auto",
              maxWidth: 500,
              padding: 48,
              direction: "rtl",
            }}
          >
            אין ספורטאים לאישור כרגע.
          </div>
        )}
        {/* Students Table Section */}
        {hasAnyNewStudents && (
          <div style={sectionCardStyle} className="modern-student-card">
            <div
              style={{
                fontWeight: 700,
                fontSize: "1.4rem",
                color: "#1976d2",
                borderRight: "6px solid #1976d2",
                paddingRight: 16,
                marginBottom: 24,
                display: "flex",
                alignItems: "center",
                gap: 10,
                direction: "rtl",
              }}
            >
              <IoReturnDownForward className="modern-section-header-icon" />
              כל הספורטאים הממתינים לאישור
            </div>
            <div className="modern-students-table">
              <DataTable
                messageIfEmpty="אין ספורטאים לאישור"
                type="newstudents"
                data={studentsToReview}
                style={{ width: "100%" }}
                columnMapping={{
                  paymentCheckData: "פרטי אימות תשלום",
                  address: "כתובת",
                  age: "גיל",
                  gender: "מין",
                  name: "שם החניך",
                  groupsIDs: "קבוצת החניך",
                  studentCreatedAt: "זמן הרשמה",
                }}
                ignoredAttributes={[
                  "id",
                  "beltColor",
                  "beltLevel",
                  "displayGroups",
                  "birthday",
                  "classPresenceRecords",
                  "firstParentEmailAddress",
                  "firstParentName",
                  "firstParentNumber",
                  "imageURI",
                  "imageUploadTime",
                  "specialFields",
                  "status",
                  "weight",
                  "weightKG",
                  "secondParentEmailAddress",
                  "secondParentName",
                  "secondParentNumber",
                  "IDnumber",
                  "studentID",
                  "studentCreatedTime",
                  "studentSource",
                  "createdAt",
                  "shortsSize",
                  "pantsSize",
                  "studentCreatedAt",
                  "formattedCreatedAt",
                ]}
                onRowClick={onNewStudentRowClick}
                metaData={groups}
              />
            </div>
          </div>
        )}
        {showStudentApproveModal && (
          <Modal
            show={showStudentApproveModal}
            onHide={() => {
              setShowStudentApproveModal(false);
            }}
            className="modern-modal"
          >
            <Modal.Header className="hebrewHeader">
              <Modal.Title className="hebrewText">
                אישור חניך - {selectedStudent.name}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="hebrewText">האם תרצה לאשר או לדחות את חניך זה?</p>
              <p className="hebrewText">
                שים לב! דחיית החניך תגרום למחיקת הפרטים שלו מהמערכת
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="danger"
                onClick={() => setShowDeleteConfirmationModal(true)}
                disabled={isDeleting || isAccepting}
              >
                דחה את החניך
              </Button>
              <Button
                variant="success"
                onClick={handleAcceptStudent}
                disabled={isDeleting || isAccepting}
              >
                {isAccepting ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginLeft: "8px" }}
                    />
                    מאשר...
                  </>
                ) : (
                  "אשר את החניך"
                )}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowStudentApproveModal(false);
                }}
                disabled={isDeleting || isAccepting}
              >
                ביטול
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {/* Delete Confirmation Modal */}
        <Modal
          show={showDeleteConfirmationModal}
          onHide={() => setShowDeleteConfirmationModal(false)}
          className="modern-modal"
        >
          <Modal.Header className="hebrewHeader">
            <Modal.Title className="hebrewText">
              אישור מחיקה - {selectedStudent?.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="hebrewText">האם אתה בטוח שברצונך למחוק את החניך?</p>
            <p className="hebrewText" style={{ color: "red" }}>
              פעולה זו לא ניתנת לביטול!
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={handleDeleteStudent}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginLeft: "8px" }}
                  />
                  מוחק...
                </>
              ) : (
                "מחק את החניך"
              )}
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteConfirmationModal(false)}
              disabled={isDeleting}
            >
              ביטול
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default NewStudentsPane;
